import React, { useEffect, useState, useContext } from 'react';
import { useParams, Link } from 'react-router-dom';
import { Card, Row, Col } from 'react-bootstrap';
import { FaMask } from 'react-icons/fa';
import { BsArrowLeft } from 'react-icons/bs';
import PageHeader from 'Utils/PageHeader';
import FetchContainer from 'Utils/FetchContainer';
import { engineLabels, EngineIcon } from 'Utils';
import { isFileBasedDatasourceType } from 'Utils/fileTypeUtils';
import AppContext from 'Utils/AppContext';
import FlaggedFields from 'SensitiveDataLandscape/DataSourceRiskProfile/FlaggedFields';
import TimeSeriesChart from 'SensitiveDataLandscape/DataSourceRiskProfile/TimeSeriesChart';
import MaskingStatus from './MaskingStatus';
import { getMaskingSummary } from './api';

const MaskingSummary = () => {
  const { id } = useParams();
  const { connections } = useContext(AppContext);
  const [summary, setSummary] = useState(null);
  const [fetchingData, setFetchingData] = useState(true);
  const [error, setError] = useState(null);

  const source = (connections || []).find((c) => c && String(c.id) === String(id));
  const sourceName = source?.name || `Data source #${id}`;
  const engine = source?.type || '';
  const isFileBased = isFileBasedDatasourceType(source?.datasourceType);

  useEffect(() => {
    const init = async () => {
      setFetchingData(true);
      setError(null);
      try {
        const result = await getMaskingSummary(id);
        setSummary(result);
      } catch (e) {
        console.log(e);
        setError(e.message);
      }
      setFetchingData(false);
    };
    if (id) init();
  }, [id]);

  const data = summary || {};

  return (
    <FetchContainer fetchingData={fetchingData} absolute={true} error={error}>
      <div>
        <Link to='/secure' className='d-inline-flex align-items-center mb-2' style={{ fontSize: '14px' }}>
          <BsArrowLeft className='mr-1' /> Secure Data Landscape
        </Link>
        <div className='title-div'>
          <PageHeader
            header={sourceName}
            tooltip='Review what was masked for this data source and how masking changed over time.'
            icon={FaMask}
          />
          {engine && (
            <p>
              {/* Engine note doubles as a shortcut to this source's editor. */}
              <Link
                to={`/sources/source-editor/${encodeURIComponent(id)}`}
                title='Open the data source editor'
                data-testid='summary-engine-source-link'
              >
                <EngineIcon engine={engine} /> {engineLabels[engine] || engine}
              </Link>
            </p>
          )}
        </div>
        <div>
          <div><h5 className='text-left h-secondary'>MASKING SUMMARY</h5></div>
          <Card>
            <Card.Body>
              <Row className='mb-1'>
                <Col xs='4' className='pl-1 pr-1'>
                  <MaskingStatus
                    rowsMasked={data.rowsMasked}
                    durationMs={data.durationMs}
                    errorCount={data.errorCount}
                    errorDetail={data.errorDetail}
                  />
                </Col>
                <Col className='flex-grow-1 pl-1 pr-1'>
                  <FlaggedFields
                    totalTables={data.totalTables}
                    totalColumns={data.totalFields}
                    sensitiveTables={data.maskedTables}
                    sensitiveColumns={data.maskedFields}
                    isFileBased={isFileBased}
                  />
                </Col>
              </Row>
            </Card.Body>
          </Card>
          <Row className='mb-1'>
            <Col>
              <TimeSeriesChart
                title='MASKING RESULTS OVER TIME'
                searchid={data.searchid}
                findings={data.findings}
                timeSeriesData={data.timeSeriesData}
                getResultHref={(jobId) => `/secure/mask/results/${jobId}`}
                maskingHint={true}
              />
            </Col>
          </Row>
        </div>
      </div>
    </FetchContainer>
  );
};

export default MaskingSummary;
